import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import { CardContent, CardMedia } from '@mui/material';

import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import { Card, Title } from 'common';
import { Course } from 'api/courses';

import { useLanguage } from '../../../context/LanguageContext'


interface CourseCardProps {
    coursesItem: Course;
}

export const CourseCard = ({ coursesItem }: CourseCardProps) => {
    const { language } = useLanguage();

    return (
        <Link to={`/courses/${coursesItem.id}`} style={{ textDecoration: 'none' }}>
            <Card sx={{ maxWidth: 345, marginBottom: 2, border: '1px solid #af0000' }}>
                {coursesItem.images && coursesItem.images.length > 0 && coursesItem.images[0] ? (
                    <CardMedia
                        component="img"
                        height="200"
                        sx={{ borderRadius: 1 }}
                        image={coursesItem.images[0].photo}
                        alt={coursesItem.title}
                    />
                ) : (
                    <ImageNotSupportedIcon
                        sx={{
                            height: 200,
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '5rem'
                        }}
                    />
                )}
                <CardContent>
                    <Title
                        gutterBottom
                        variant="h5"
                        component="div"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2, // количество строк, для отображения
                            fontWeight: 600,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {coursesItem[`title_${language}`]}
                    </Title>
                    <Title
                        gutterBottom
                        variant="body1"
                        color="text.secondary"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 4, // количество строк, для отображения
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        <div dangerouslySetInnerHTML={{
                            __html: coursesItem[`description_${language}`]
                        }} />
                    </Title>
                    <Title variant="body2" color="text.primary">
                        {dayjs(coursesItem.created_at).format('DD.MM.YYYY')}
                    </Title>
                    <Title variant="body1" color="#af0000">
                        {coursesItem[`category_${language}`]}
                    </Title>
                </CardContent>
            </Card>
        </Link>
    );
};
